export default {
    ENTRADA: 1,
    SOLICITADO: 2,
    REJEITADO: 3,
    APROVADO: 4
};